<mat-dialog-content class="modal-header"><h2 mat-dialog-title>REGISTRAR VEHÍCULO</h2></mat-dialog-content>

<form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>

<mat-dialog-content class="modal-body">

  <div class="content">

    <div class="block-header">
      <h3 class="block-title">Datos del vehículo</h3>
    </div>
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-2 control-label">Marca (*):</label>
        <div class="col-md-2">
          <mat-form-field appearance="outline" hideRequiredMarker>
            <mat-label>Marca</mat-label>
            <input matInput type="text" placeholder="marca" [(ngModel)]="data.vehiculo.marca" [disabled]="!data.enableEdit"  maxlength="20"
            name="marca"
            required
            >
          </mat-form-field>                
        </div>
        <label class="col-md-2 control-label">Año:</label>
        <div class="col-md-2">
          <mat-form-field appearance="outline">
            <mat-label>Año</mat-label>
            <input matInput type="text" placeholder="año" [(ngModel)]="data.vehiculo.anio" [disabled]="!data.enableEdit" maxlength="4"
            min="1990"
            max="2021"
            minlength="4" maxlength="4"
            name="anio"
            #anio="ngModel"

            pattern="^(19|20)\d{2}$"
            (keypress)="keyPressNumberOnly($event)"
            [ngModelOptions]="{ updateOn: 'blur' }"
            >
          </mat-form-field>
        </div> 
        <label class="col-md-2 control-label">Combustible:</label>
        <div class="col-md-2">
          <mat-form-field appearance="outline">
            <mat-label>Combustible</mat-label>
            <input matInput type="text" placeholder="combustible" [(ngModel)]="data.vehiculo.combustible" [disabled]="!data.enableEdit" maxlength="12"
            name="combustible"
            />
          </mat-form-field>            
        </div>         
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Placa:</label>
        <div class="col-md-2">
          <mat-form-field appearance="outline">
            <mat-label>Placa</mat-label>
            <input matInput type="text" placeholder="placa" [(ngModel)]="data.vehiculo.placa" [disabled]="!data.enableEdit" maxlength="10"
            name="placa"
            />
          </mat-form-field>            
        </div>
        <label class="col-md-2 control-label">Color:</label>
        <div class="col-md-2">
          <mat-form-field appearance="outline">
            <mat-label>Color</mat-label>
            <input matInput type="text" placeholder="color" [(ngModel)]="data.vehiculo.color" [disabled]="!data.enableEdit" maxlength="10"
            name="color"
            />
          </mat-form-field>          
        </div>
        <label class="col-md-2 control-label">T. Propiedad:</label>
        <div class="col-md-2">
          <mat-form-field appearance="outline">
            <mat-label>Tarjeta de Propiedad</mat-label>
            <input matInput type="text" placeholder="t. propiedad" [(ngModel)]="data.vehiculo.tarjetaPropiedad" [disabled]="!data.enableEdit" maxlength="15"
            name="tarjetaPropiedad"
            />
          </mat-form-field>          
        </div>         
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Soat:</label>
        <div class="col-md-2">
          <mat-form-field appearance="outline">
            <mat-label>Soat</mat-label>
            <input matInput type="text" placeholder="soat" [(ngModel)]="data.vehiculo.soat" [disabled]="!data.enableEdit" maxlength="15"
            name="soat"
            />
          </mat-form-field>          
        </div>
        <label class="col-md-2 control-label">Modelo (*):</label>
        <div class="col-md-2">
          <mat-form-field appearance="outline" hideRequiredMarker>
            <mat-label>Modelo</mat-label>
            <input matInput type="text" placeholder="modelo" [(ngModel)]="data.vehiculo.modelo" [disabled]="!data.enableEdit" maxlength="20"
            name="modelo"
            required
            />
          </mat-form-field>          
        </div>   
        <label class="col-md-2 control-label">Tipo Vehiculo (*):</label>
        <div class="col-md-2">
          <mat-form-field appearance="outline" hideRequiredMarker>
            <mat-label>Tipo Vehiculo</mat-label>
            <input matInput type="text" placeholder="t. vehiculo" [(ngModel)]="data.vehiculo.tipoVehiculo" [disabled]="!data.enableEdit" maxlength="100"
            name="tipoVehiculo"
            required
            />
          </mat-form-field>          
        </div>
      </div>      
    </div>


    <div class="block-header">
      <h3 class="block-title">Datos del chofer</h3>
    </div>
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-2 control-label">Apellido paterno (*):</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline" hideRequiredMarker>
            <mat-label>Apellido paterno</mat-label>
            <input matInput type="text" placeholder="apellido paterno" [(ngModel)]="data.vehiculo.solicitudChofer.apellidoPaterno" [disabled]="!data.enableEdit" maxlength="40"
            name="apellidoPaterno"
            required
            />
          </mat-form-field>          
        </div>
        <label class="col-md-2 control-label">Apellido materno (*):</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline" hideRequiredMarker>
            <mat-label>Apellido materno</mat-label>
            <input matInput type="text" placeholder="apellido materno" [(ngModel)]="data.vehiculo.solicitudChofer.apellidoMaterno" [disabled]="!data.enableEdit" maxlength="40"
            name="apellidoMaterno"
            required
            />
          </mat-form-field>          
        </div>       
      </div>      
      <div class="form-group">
        <label class="col-md-2 control-label">Nombres (*):</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline" hideRequiredMarker>
            <mat-label>Nombres</mat-label>
            <input matInput type="text" placeholder="nombres" [(ngModel)]="data.vehiculo.solicitudChofer.nombres" [disabled]="!data.enableEdit" maxlength="40"
            name="nombres"
            required
            />
          </mat-form-field>          
        </div>
        <label class="col-md-2 control-label">Nro Licencia (*):</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline" hideRequiredMarker>
            <mat-label>Nro Licencia</mat-label>
            <input matInput type="text" placeholder="licencia" [(ngModel)]="data.vehiculo.solicitudChofer.nroLicencia" [disabled]="!data.enableEdit" maxlength="15"
            name="nroLicencia"
            required
            />
          </mat-form-field>          
        </div>        
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Tipo de licencia (*):</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline" hideRequiredMarker>
            <mat-label>Tipo de licencia</mat-label>
            <input matInput type="text" placeholder="tipo licencia" [(ngModel)]="data.vehiculo.solicitudChofer.tipoLicencia" [disabled]="!data.enableEdit" maxlength="20"
            name="tipoLicencia"
            required
            />
          </mat-form-field>          
        </div>
      </div>

    </div>

  </div>  
  <div class="content">
    <div class="block">
      <!-- <div class="block-header">
        <h3 class="block-title">Documentación Requerida</h3>
      </div> -->
      <mat-tab-group>
        <mat-tab label="Documentación Requerida">
        <div class="table-responsive">
          <table mat-table [dataSource]="data.vehiculo.documentos" class="table table-striped table-vcenter">
            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
            </ng-container>
    
            <ng-container matColumnDef="idRequisito">
              <th mat-header-cell *matHeaderCellDef>Requisito</th>
              <td mat-cell *matCellDef="let element">{{ element.requisito }}</td>
            </ng-container>

            <ng-container matColumnDef="fechaVencimiento">
              <th mat-header-cell *matHeaderCellDef>Fecha de vencimiento</th>
              <td mat-cell *matCellDef="let element; let i = index">
                <ng-container *ngIf="element.idEstado == 1">
                  {{ element.fechaVencimiento | date:'dd/MM/yyyy' }}
                </ng-container>

                <ng-container *ngIf="element.idEstado !== 1">

                  <mat-form-field appearance="outline" *ngIf="element.controlarFechas">
                    <input
                      matInput
                      [matDatepicker]="pckrFechaVencimiento"
                      [(ngModel)]="element.fechaVencimiento"
                      [name]="'fechaVencimiento_'+ i"
                    />
                    <!-- [disabled]="element.idEstado == 1" -->
                    <!-- element.idEstado === 1 -->
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="pckrFechaVencimiento"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pckrFechaVencimiento></mat-datepicker>    
                  </mat-form-field>


                </ng-container>
                

              </td>
            </ng-container>

            <ng-container matColumnDef="idDocumento">
              <th mat-header-cell *matHeaderCellDef>Doc.</th>
              <td mat-cell *matCellDef="let element">
                <!-- <a>VER</a> -->
                <a (click)="downloadDocumentFromService(element)">{{element.nombreArchivo}}</a>
              </td>
            </ng-container>

            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef>Estado</th>
              <td mat-cell *matCellDef="let element">
                <!-- <a>VER</a> -->
                {{element.estado}}
              </td>
            </ng-container>

            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let element"> 
                <app-adjuntar-documento 
                  *ngIf="element.idEstado == 0 || element.idEstado == 2"  
                  [codigoSolicitud]="data.vehiculo.codigoSolicitud" 
                  [filename]="element.nombre" 
                  [idSolicitud]="data.vehiculo.idSolicitud" 
                  [model]="element" 
                  [tipoSeccion]="tipoSeccion" 
                  (onUploadFinished)="addItem($event)"
                  (onRemoveDocument)="removeItem($event)"
                  >
                </app-adjuntar-documento>
              </td>
            </ng-container>
            
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
        </mat-tab>  
        <mat-tab label="Historial Comentarios">
          <app-log-table [listaLogModel]="logs"></app-log-table>
        </mat-tab>
      </mat-tab-group>
      <!-- <div class="block-content">
      </div> -->
    </div>
  </div>
  
  <div class="content">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-2 control-label">Comentarios:</label>
        <div class="col-md-9">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>Comentarios</mat-label>
            <textarea
              matInput
              placeholder="Comentarios"
              rows="5"
              name="comentarios"
              [(ngModel)]="data.vehiculo.comentarios" [maxlength]="2000"
            ></textarea>
            <!-- 
              [disabled]="modelVehiculo.idEstado === 2" -->
            <!-- [disabled]="modelVehiculo.idEstado !== 0" -->
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <!-- <pre>{{data.vehiculo.documentos | json}}</pre> -->
  
</mat-dialog-content>

<mat-dialog-actions align="end" class="modal-actions">
  <button type="submit" class="btn btn-naranja" [disabled]="modelForm.invalid" mat-button><mat-icon>save</mat-icon> Guardar</button>
  <!-- cdkFocusInitial -->
  <button type="button" class="btn btn-naranja2" mat-button (click)="onNoClick()"><mat-icon>exit_to_app</mat-icon> Cancelar</button>
</mat-dialog-actions>
</form>
